import React, { useRef, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import * as THREE from 'three'
import { Canvas, useFrame, useThree } from 'react-three-fiber'
import { OrbitControls, Stars, Text, meshBounds } from '@react-three/drei'

const vertices = [
  // Bottom face
  -1, -1, -1,
  1, -1, -1,
  0, -1, 1,
  // Top face
  0.0, 0.816496580927726, -0.2
];

const indices = [
  // Bottom face
  0, 1, 2,
  // Front face
  3, 1, 0,
  // Right face
  3, 2, 1,
  // Back face
  3, 0, 2
];

function SadwareWord() {
  const { viewport } = useThree()
  const [unscaledWidth, setUnscaledWidth] = useState(0)
  const fit = unscaledWidth > 0 ? Math.min(1, (viewport.width * 0.86) / unscaledWidth) : 1

  return (
    <Text
      scale={[fit, fit, fit]}
      color="white"
      anchorX="center"
      anchorY="middle"
      position={[0, -0.55, 0]}
      onSync={(troika) => {
        const bounds = troika.textRenderInfo && troika.textRenderInfo.blockBounds
        if (!bounds) return
        const next = bounds[2] - bounds[0]
        if (next > 0 && Math.abs(next - unscaledWidth) > 0.01) setUnscaledWidth(next)
      }}
    >
      SADWARE
    </Text>
  )
}

function Tetrahedron(props) {
  const mesh = useRef()

  const [active, setActive] = useState(false)

  useFrame(() => {
    // Rotate mesh every frame
    mesh.current.rotation.y += 0.01
    mesh.current.rotation.z += 0.001
  })

  const geometry = useMemo(() => {
    const geo = new THREE.BufferGeometry()
    geo.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
    geo.setIndex(indices)
    geo.computeVertexNormals()
    return geo
  }, [])

  return (
    <mesh
      {...props}
      ref={mesh}
      raycast={meshBounds}
      //scale={active ? [1.5, 1.5, 1.5] : [1, 1, 1] }
      onClick={(e) => setActive(!active)}
      geometry={geometry}
      >
       <meshPhongMaterial color="#f3f3f3" wireframe />
       {/*<meshStandardMaterial metalness={0.5} roughness={0.7} attach="material" color='#17798C' />*/}
    </mesh>
  )
}

export default function Home() {
  return (
    <div style={{ width: "100vw", height: "100vh", backgroundColor: '#000000', position: 'relative' }}>
    <Canvas>
      <ambientLight intensity={1} />
      <spotLight position={[10, 10, 10]} angle={0.15} />
      <Tetrahedron position={[0, 1.2, 0]} />
      <SadwareWord />
      <OrbitControls 
        autoRotate
        autoRotateSpeed={0.2}
      />

      <Stars
        radius={100} // Radius of the inner sphere (default=100)
        depth={50} // Depth of area where stars should fit (default=50)
        count={5000} // Amount of stars (default=5000)
        factor={4} // Size factor (default=4)
        saturation={0} // Saturation 0-1 (default=0)
        fade // Faded dots (default=false)
      />
    </Canvas>
    <div
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '0 24px 32px',
        pointerEvents: 'none',
      }}
    >
      <h1
        style={{
          margin: 0,
          maxWidth: 640,
          color: '#ffffff',
          fontWeight: 400,
          fontSize: 'clamp(22px, 3vw, 32px)',
          letterSpacing: '0.01em',
          lineHeight: 1.25,
        }}
      >
        Custom software, thoughtfully built.
      </h1>
      <p
        style={{
          margin: '12px 0 0',
          maxWidth: 460,
          color: 'rgba(255,255,255,0.84)',
          fontSize: 15,
          lineHeight: 1.5,
        }}
      >
        We build apps and software for businesses.
      </p>
      <p
        style={{
          margin: '8px 0 0',
          maxWidth: 480,
          color: 'rgba(255,255,255,0.62)',
          fontSize: 14,
          lineHeight: 1.55,
        }}
      >
        SADWARE designs and builds software for a particular purpose, including the apps below.
      </p>
      <nav
        aria-label="Apps"
        style={{
          marginTop: 26,
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 28,
          fontSize: 13,
          letterSpacing: '0.18em',
          pointerEvents: 'auto',
        }}
      >
        <Link to="/browdesigner" style={{ color: '#ffffff', textDecoration: 'none' }}>BROW DESIGNER</Link>
        <Link to="/nightdrift" style={{ color: '#ffffff', textDecoration: 'none' }}>NIGHTDRIFT</Link>
      </nav>
    </div>
    </div>
  )
}